function Loader() {
  return (
    <div className="min-h-screen h-full flex items-center justify-center">
      <div class="loader"></div>
    </div>
  );
}

export default Loader;
